import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createDealerUserAddress, updateDealerUserAddress } from '@/api/address';
import { listDealerUserManufacturer } from '@/api/manufacturer.js';
export default {
  components: {},
  data: function data() {
    return {
      dialogTitle: '',
      dialogVisible: false,
      form: {},
      formRules: {
        manuId: [{
          required: true,
          message: '请选择经销商',
          trigger: ['blur', 'change']
        }],
        address: [{
          required: true,
          message: '请填写地址',
          trigger: ['blur', 'change']
        }],
        contactPerson: [{
          required: true,
          message: '请填写联系人',
          trigger: ['blur', 'change']
        }],
        mobile: [{
          required: true,
          message: '请填写手机号',
          trigger: ['blur', 'change']
        }]
      },
      formLoading: false,
      manufacturerList: []
    };
  },
  methods: {
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this;
                that.formLoading = false;
                that.dialogVisible = true;

                if (row.ID) {
                  that.dialogTitle = '编辑地址';
                  that.form = {
                    ID: row.ID,
                    relationType: 1,
                    manuId: row.manuId,
                    address: row.address,
                    contactPerson: row.contactPerson,
                    mobile: row.mobile,
                    mark: row.mark
                  };
                } else {
                  that.dialogTitle = '新增地址';
                  that.form = {
                    ID: null,
                    relationType: 1,
                    manuId: row.manuId,
                    address: null,
                    contactPerson: null,
                    mobile: null,
                    mark: null
                  };
                }

                that.$nextTick(function () {
                  that.$refs.form.clearValidate();
                });
                that.loadManufacturer();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dialogClose: function dialogClose() {
      var that = this;
      that.$nextTick(function () {
        that.dialogVisible = false;
        that.$emit('reload');
      });
    },
    formSubmit: function formSubmit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this2;
                that.$refs.form.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid, error) {
                    var form, item;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!valid) {
                              _context2.next = 21;
                              break;
                            }

                            that.formLoading = true;
                            _context2.prev = 2;
                            form = JSON.parse(JSON.stringify(that.form));

                            if (!form.ID) {
                              _context2.next = 10;
                              break;
                            }

                            _context2.next = 7;
                            return updateDealerUserAddress(form);

                          case 7:
                            that.$notify.success('更新成功');
                            _context2.next = 13;
                            break;

                          case 10:
                            _context2.next = 12;
                            return createDealerUserAddress(form);

                          case 12:
                            that.$notify.success('新增成功');

                          case 13:
                            that.dialogClose();
                            _context2.next = 18;
                            break;

                          case 16:
                            _context2.prev = 16;
                            _context2.t0 = _context2["catch"](2);

                          case 18:
                            that.formLoading = false;
                            _context2.next = 28;
                            break;

                          case 21:
                            _context2.t1 = regeneratorRuntime.keys(error);

                          case 22:
                            if ((_context2.t2 = _context2.t1()).done) {
                              _context2.next = 28;
                              break;
                            }

                            item = _context2.t2.value;
                            that.$message.error(error[item][0].message);
                            return _context2.abrupt("return");

                          case 28:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[2, 16]]);
                  }));

                  return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    loadManufacturer: function loadManufacturer() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this3;
                that.manufacturerList = [];
                _context4.next = 4;
                return listDealerUserManufacturer().then(function (res) {
                  that.manufacturerList = res.list;
                });

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};